import { render } from "./GuestSignatureHandoffModal.vue?vue&type=template&id=5392caf8&scoped=true"
import script from "./GuestSignatureHandoffModal.vue?vue&type=script&lang=js"
export * from "./GuestSignatureHandoffModal.vue?vue&type=script&lang=js"

import "./GuestSignatureHandoffModal.vue?vue&type=style&index=0&id=5392caf8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5392caf8"]])

export default __exports__